import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, RadioGroup, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const AskForWhomStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.ask_for_whom).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handleChange = (value: string) => {
    updateSelfServiceData('passportFor', value);
  };

  const handleNext = () => {
    if (selfServiceData.passportFor) {
      goNext();
    }
  };

  const options = [
    { value: 'self', label: 'Mig selv' },
    { value: 'child', label: 'Et barn (under 18 år)' }
  ];

  return (
    <StepContainer title="Hvem ansøger du for?">
      {body ? (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      ) : (
        <p>Vælg venligst, om ansøgningen er til dig selv eller til et barn, du har forældremyndighed over.</p>
      )}

      <RadioGroup
        name="passportFor"
        options={options}
        value={selfServiceData.passportFor}
        onChange={handleChange}
        legend="Hvem ansøger du for?"
        required={true}
      />

      <NavigationButtons
        onBack={goBack}
        onNext={handleNext}
        nextDisabled={!selfServiceData.passportFor}
      />
    </StepContainer>
  );
};

export default AskForWhomStep;
